<template>
    <div class="image-uploader">
        <div class="flex items-center gap-3 xl:gap-4">
            <slot name="preview-image">
                <div class="border border-ui-lines overflow-hidden rounded h-16 w-16 flex-center">
                    <img
                        :src="image"
                        :alt="imageName"
                        class="w-full h-auto object-contain"
                    >
                </div>
            </slot>
            <div>
                <ElUpload
                    action="default"
                    :accept="imageAccept || DEFAULT_ACCEPT"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="onFileChange"
                >
                    <RedesignBaseButton
                        color="primary"
                        type="soft"
                        icon="IconPencil"
                    >
                        {{ $t('common.edit') }}
                    </RedesignBaseButton>
                </ElUpload>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Upload as ElUpload } from 'element-ui'
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'
import useNotifyService from '@/composables/useNotifyService'
import { getBase64 } from '@/helpers/util'
import type { ElUploadInternalFileDetail } from 'element-ui/types/upload'

const DEFAULT_ACCEPT = '.jpg, .png, .jpeg'
const MAX_SIZE = 100000

const props = defineProps<{
    image?: string
    imageName?: string
    disabled?: boolean
    imageAccept?: string
    maxSize?: number
}>()
const emit = defineEmits([ 'on-success' ])

async function onFileChange (file: ElUploadInternalFileDetail) {
    const size = file.size
    const sizeLimit = props.maxSize || MAX_SIZE
    if (size > sizeLimit) {
        useNotifyService.add({
            type: 'error',
            title: `Invalid ${props.imageName}`,
            message: `Size should be less than ${sizeLimit / 1000}kb`
        })
        return
    }
    const result = await getBase64(file.raw)
    emit('on-success', result)
}
</script>
